/**
 * エントリーポイント
 *
 * index.html の <div id="root"></div> に React を流し込むだけのファイル。
 * グローバルCSSもここで一度だけ読み込む（main.tsx 以外で読まない）。
 *
 * 本番ビルドのみ Service Worker を登録する（HMR との競合を避けるため）。
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { migrateHistoryIfNeeded } from './lib/storage';

import './styles/global.css';

// v0.2 までの単一履歴キーを v0.3 のモード別キーへ移行（idempotent）
migrateHistoryIfNeeded();

const rootElement = document.getElementById('root');

if (!rootElement) {
  // index.html を編集しない限り起こらないが、原因が分かるエラーを出しておく
  throw new Error('root 要素が見つかりません。index.html を確認してください。');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service Worker は本番でのみ登録（推奨案 Q5-A）
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.debug('[sw] registered, scope:', reg.scope);
      })
      .catch((err: unknown) => {
        console.warn('[sw] register failed:', err);
      });
  });
}
